/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'
import { DriverIconLinkEmployeeFragmentDoc } from '../DriverIconLink/driverIconLink.hook'
export type MetaPhoneDriverVehicleFragment = {
  __typename?: 'Vehicle'
  hardwareConfiguration: {
    __typename?: 'HardwareConfiguration'
    tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
  } | null
}

export type MetaPhoneDriverEmployeeFragment = {
  __typename?: 'Employee'
  id: string
  firstName: string | null
  lastName: string | null
}

export const MetaPhoneDriverVehicleFragmentDoc = gql`
    fragment MetaPhoneDriverVehicle on Vehicle {
  hardwareConfiguration {
    tablet {
      phoneNumber
    }
  }
}
    `
export const MetaPhoneDriverEmployeeFragmentDoc = gql`
    fragment MetaPhoneDriverEmployee on Employee {
  ...DriverIconLinkEmployee
}
    ${DriverIconLinkEmployeeFragmentDoc}`
